export const en: Record<string, string> = {
  // ------------------------------------------------------------ general
  'app.title': 'Knight',
  'app.tagline': 'Dark fantasy realms. Fall, and haunt the living.',
  'app.offline': 'Offline mode: the server is unreachable, you play alone against your own fallen heroes.',
  'app.connecting': 'Connecting…',
  'app.reconnect': 'Reconnect',
  'btn.play': 'Enter the realm',
  'btn.duel': 'Duel',
  'btn.squad': 'Squad',
  'btn.guild': 'Guild',
  'btn.profile': 'Profile',
  'btn.leaderboards': 'Leaderboards',
  'btn.settings': 'Settings',
  'btn.back': 'Back',
  'btn.close': 'Close',
  'btn.copy': 'Copy link',
  'btn.copied': 'Copied!',
  'btn.cancel': 'Cancel',
  'btn.save': 'Save',
  'btn.leave': 'Leave',
  'btn.continue': 'Continue',
  'btn.menu': 'To menu',
  'btn.respawn': 'Return as {hero}',
  'btn.chooseHero': 'Choose a hero',
  'btn.start': 'Start',
  'btn.ready': 'Ready',
  'btn.invite': 'Invite friends',
  'btn.google': 'Sign in with Google',
  'btn.signout': 'Sign out',
  'btn.create': 'Create',
  'btn.join': 'Join',
  'btn.kick': 'Kick',
  'btn.share': 'Share',
  'btn.avenge': 'Avenge',
  'btn.queue': 'Find an opponent',
  'btn.queueCancel': 'Cancel search',
  'label.code': 'Code',
  'label.players': 'Players',
  'label.level': 'Level',
  'label.lvl': 'Lv.',
  'label.fame': 'Fame',
  'label.rating': 'Rating',
  'label.kills': 'Kills',
  'label.bossKills': 'Bosses slain',
  'label.revenantKills': 'Revenants slain',
  'label.damage': 'Damage dealt',
  'label.survived': 'Survived',
  'label.killedBy': 'Slain by',
  'label.build': 'Build',
  'label.weapon': 'Weapon',
  'label.armor': 'Armor',
  'label.charm': 'Charm',
  'label.traits': 'Traits',
  'label.keystones': 'Keystones',
  'label.actives': 'Active skills',
  'label.autos': 'Auto skills',
  'label.consumables': 'Consumables',
  'label.stats': 'Stats',
  'label.guest': 'Guest',
  'label.name': 'Name',
  'label.avatar': 'Avatar',
  'label.language': 'Language',
  'label.online': 'online',
  'label.offline': 'offline',
  'label.leader': 'Leader',
  'label.member': 'Member',
  'label.points': 'Points',
  'label.members': 'Members',
  'label.rank': '#',
  'label.you': 'you',
  'label.none': 'none',
  'label.empty': 'empty',
  'label.sec': '{n}s',
  'label.min': '{m}m {s}s',
  'label.new': 'New',
  'label.upgrade': 'Upgrade',
  'label.key': 'Key',
  'label.controls': 'Controls',
  'label.ready': 'ready',
  'label.notReady': 'picking',
  'label.inGame': 'in the realm',
  'label.tier': 'Tier {n}',
  'label.elite': 'Elite',
  'label.revenant': 'Revenant',
  'label.boss': 'Realm boss',
  'label.corruption': 'Corruption',
  'label.realm': 'Realm',
  'label.round': 'Round {n}',
  'label.wins': 'Wins',
  'label.searching': 'Searching for an opponent…',
  'label.found': 'Opponent found!',
  'label.version': 'prototype',
  'label.guildTag': 'Tag',
  'label.guildName': 'Guild name',
  'label.joinByCode': 'Join by code',
  'label.noGuild': 'You are not in a guild yet. Create one or join by code.',
  'label.referral': 'Friends invited',
  'label.titles': 'Titles',
  'label.recentNotices': 'News',
  'label.rarity0': 'Common',
  'label.rarity1': 'Rare',
  'label.rarity2': 'Epic',
  'label.aspect': 'Aspect',
  'label.aspectPick': 'Choose the aspect of {skill}',
  'label.keystonePick': 'Choose a keystone',
  'label.draftPick': 'Level {n}: a skill rank or a blessing',
  'label.autoPickIn': 'auto-pick in {s}s',
  'label.startingKit': 'Starting kit',
  'label.heroTrait': 'Hero trait',
  'label.leaning': 'Leans toward',
  'label.deathTitle': 'You have fallen',
  'label.deathSub': '{name} now haunts other realms as a revenant.',
  'label.shareDeath': 'Fight my revenant',
  'label.shareText': 'My {hero} fell at level {level} with {kills} kills in Knight. Face my revenant: {url}',
  'label.shareSquad': 'Join my squad in Knight: {url}',
  'label.avengeHint': 'A revenant awaits you in this realm.',
  'label.chatPlaceholder': 'Press Enter to chat…',
  'label.feed': 'Realm feed',
  'label.spectating': 'Waiting to return…',
  'label.pressToRespawn': 'Choose a hero to return to the realm',
  'label.realmEnding': 'The realm collapses in {s}s. A new realm awaits.',
  'label.bossApproaches': 'Corruption is rising. The boss will come when it fills.',
  'label.google.linked': 'Google account linked',
  'label.google.hint': 'Sign in to keep your progress on any device. Your guest progress will be moved to the account.',
  'label.google.unavailable': 'Google sign-in is not configured on this server.',
  'label.google.merge': 'This Google account already has progress. Continue with it? Your guest progress stays on this device as a separate guest.',
  'label.settingsHint': 'Settings are stored in this browser.',
  'set.master': 'Master volume',
  'set.sfx': 'Effects',
  'set.music': 'Music',
  'set.shake': 'Screen shake',
  'set.dmg': 'Damage numbers',
  'set.names': 'Player names',
  'set.autofire': 'Auto-fire',
  'set.minimap': 'Minimap',
  'set.othersProj': 'Dim other players\' projectiles',
  'ctl.move': 'Move',
  'ctl.aim': 'Aim',
  'ctl.fire': 'Attack (hold)',
  'ctl.dash': 'Dash',
  'ctl.skills': 'Skills 1–4',
  'ctl.cons': 'Consumables 1–4',
  'ctl.pick': 'Draft picks',
  'ctl.interact': 'Interact',
  'ctl.build': 'Build panel',
  'ctl.chat': 'Chat',
  'ctl.menu': 'Menu',
  'ctl.map': 'Minimap',
  'ctl.autofire': 'Toggle auto-fire',
  'toast.copied': 'Link copied to clipboard',
  'toast.saved': 'Saved',
  'toast.nameBad': 'Name must be 2–16 letters, digits or spaces',
  'toast.error': 'Something went wrong: {msg}',
  'toast.guildCreated': 'Guild created',
  'toast.guildJoined': 'You joined the guild',
  'toast.guildLeft': 'You left the guild',
  'toast.squadFull': 'The squad is full',
  'toast.squadNotFound': 'Squad not found',
  'toast.needServer': 'This needs a connection to the server',
  'toast.referral': 'Welcome! You and your friend earned fame.',
  'lb.fame': 'Fame',
  'lb.bestLevel': 'Best level',
  'lb.bossKills': 'Bosses',
  'lb.revenantKills': 'Revenants',
  'lb.rating': 'Duels',
  'lb.guilds': 'Guilds',
  'title.founder': 'Founder',
  'title.recruiter': 'Recruiter',
  'title.slayer': 'Slayer',
  'title.duelist': 'Duelist',
  'notice.revenantSlain': 'Your revenant {ghost} was slain by {killer}. +{fame} fame.',
  'notice.referral': '{name} joined through your link. +{fame} fame.',
  'notice.duelWon': 'You won a duel against {name}. Rating {rating}.',
  'notice.duelLost': 'You lost a duel to {name}. Rating {rating}.',

  // ------------------------------------------------------------ in-game announcements & feed
  'announce.bossArrives': 'The {boss} has entered the realm!',
  'announce.bossSlain': '{killer} struck the final blow. The {boss} is no more.',
  'announce.bossPhase': 'The {boss} grows desperate ({phase})',
  'duel.fight': 'Fight!',
  'duel.victory': '{name} wins the duel!',
  'duel.roundWon': '{name} takes the round',
  'duel.draft': 'Draft your build',
  'duel.countdown': 'Get ready…',
  'duel.waiting': 'Waiting for an opponent',
  'duel.end': 'Duel over',
  'duel.won': 'Victory',
  'duel.lost': 'Defeat',
  'feed.joined': '{name} entered the realm',
  'feed.left': '{name} left the realm',
  'feed.revenantAppears': 'A revenant of {name} stalks the realm',
  'feed.revenantSlain': '{killer} slew the revenant of {name}',
  'feed.bossSlain': '{killer} slew the {boss}',
  'feed.pvpKill': '{killer} defeated {victim}',

  // ------------------------------------------------------------ heroes
  'hero.revenant.name': 'Revenant',
  'hero.revenant.desc': 'A knight who already died once. Heavy armor, a claymore and the shades of the fallen at his call. Leans toward tank, summons and reflected damage, but nothing stops him from picking up a bow.',
  'hero.revenant.trait': 'Cursed Resolve',
  'hero.revenant.traitDesc': '+10 armor. Summons deal +15% and inherit half of your armor.',
  'hero.pilgrim.name': 'Pilgrim',
  'hero.pilgrim.desc': 'A wandering archer of a forgotten faith. Fast arrows, crits and light that mends allies. Leans toward ranged damage and healing.',
  'hero.pilgrim.trait': 'Mercy',
  'hero.pilgrim.traitDesc': '+5% crit, +20% healing. Hits have a chance to heal the most wounded ally nearby.',
  'hero.hexer.name': 'Hexer',
  'hero.hexer.desc': 'A witch of the coven that never burned. Homing bolts, curses and auras. Leans toward buffs, debuffs and elemental chaos.',
  'hero.hexer.trait': 'Coven',
  'hero.hexer.traitDesc': 'Auras are 40% stronger and wider, effect durations +20%, curses last longer.',

  // ------------------------------------------------------------ active skills
  'skill.wail.name': 'Wail of the Fallen',
  'skill.wail.desc': 'Call two shades to fight beside you for {dur}s.',
  'skill.light_volley.name': 'Volley of Light',
  'skill.light_volley.desc': 'A cone of five piercing holy arrows.',
  'skill.hex.name': 'Hex',
  'skill.hex.desc': 'Curse an area: enemies inside are Vulnerable and Weak for 5s.',
  'skill.fireball.name': 'Fireball',
  'skill.fireball.desc': 'A ball of fire that explodes on impact and sets enemies burning.',
  'skill.frost_nova.name': 'Frost Nova',
  'skill.frost_nova.desc': 'A burst of frost around you chills everything nearby.',
  'skill.chain_lightning.name': 'Chain Lightning',
  'skill.chain_lightning.desc': 'Lightning that jumps between four enemies and shocks them.',
  'skill.shield_bash.name': 'Shield Bash',
  'skill.shield_bash.desc': 'Lunge forward, stunning and knocking enemies in your path.',
  'skill.blood_rite.name': 'Blood Rite',
  'skill.blood_rite.desc': 'Sacrifice 15% health: enemies around you bleed and you gain Might.',
  'skill.holy_ward.name': 'Holy Ward',
  'skill.holy_ward.desc': 'Allies nearby gain Fortify, Regen, a shield and are healed.',
  'skill.void_rift.name': 'Void Rift',
  'skill.void_rift.desc': 'Tear a rift that pulls enemies in and grinds them for 3s.',
  'skill.arrow_storm.name': 'Arrow Storm',
  'skill.arrow_storm.desc': 'Arrows rain on an area for 3s.',
  'skill.war_cry.name': 'War Cry',
  'skill.war_cry.desc': 'Allies gain Might and Haste; enemies nearby are taunted to you.',

  // ------------------------------------------------------------ auto skills
  'skill.orbit_blades.name': 'Orbiting Blades',
  'skill.orbit_blades.desc': 'Two blades circle you, slashing whatever they touch.',
  'skill.ember_aura.name': 'Ember Aura',
  'skill.ember_aura.desc': 'Enemies near you keep catching fire.',
  'skill.frost_pulse.name': 'Frost Pulse',
  'skill.frost_pulse.desc': 'Every few seconds a pulse chills enemies around you.',
  'skill.spirit_bolt.name': 'Spirit Bolt',
  'skill.spirit_bolt.desc': 'Homing void bolts seek the nearest enemy.',
  'skill.bone_shards.name': 'Bone Shards',
  'skill.bone_shards.desc': 'A ring of piercing shards bursts from you periodically.',
  'skill.blight_cloud.name': 'Blight Cloud',
  'skill.blight_cloud.desc': 'A poisonous cloud lingers where you stand.',
  'skill.guardian_totem.name': 'Guardian Totem',
  'skill.guardian_totem.desc': 'Plant a totem that shoots at enemies.',
  'skill.mirror_shards.name': 'Mirror Shards',
  'skill.mirror_shards.desc': 'Whenever you take damage, shards fly back at your attackers.',

  // ------------------------------------------------------------ traits
  'skill.iron_skin.name': 'Iron Skin',
  'skill.iron_skin.desc': '+15 armor (+10 per level).',
  'skill.glass_heart.name': 'Glass Heart',
  'skill.glass_heart.desc': '+25% damage, −15% max health.',
  'skill.swift.name': 'Swift',
  'skill.swift.desc': '+12% move speed, dash recharges 15% faster.',
  'skill.bloodlust.name': 'Bloodlust',
  'skill.bloodlust.desc': '+5% damage. Kills grant Haste for 2s.',
  'skill.pyromancer.name': 'Pyromancer',
  'skill.pyromancer.desc': 'Status effects +15%. Fire hits may add Burn; burning enemies spread fire when they die.',
  'skill.cryomancer.name': 'Cryomancer',
  'skill.cryomancer.desc': 'Status effects +15%. Frost hits may add Chill. Five Chill stacks shatter for bonus damage.',
  'skill.stormcaller.name': 'Stormcaller',
  'skill.stormcaller.desc': '+8% damage. Kills may release chain lightning.',
  'skill.plague_doctor.name': 'Plague Doctor',
  'skill.plague_doctor.desc': 'Status effects +20%. Blight spreads to nearby enemies when its victim dies.',
  'skill.thorns.name': 'Thorns',
  'skill.thorns.desc': 'Reflect 25% of damage taken (+20% per level).',
  'skill.shepherd.name': 'Shepherd',
  'skill.shepherd.desc': '+1 summon, summons +20% power.',
  'skill.zealot.name': 'Zealot',
  'skill.zealot.desc': 'Healing +30%, damage +5%. Your heals also smite nearby enemies.',
  'skill.marksman.name': 'Marksman',
  'skill.marksman.desc': '+1 projectile, +8% crit chance.',
  'skill.vampiric.name': 'Vampiric',
  'skill.vampiric.desc': '5% of damage dealt returns as health.',
  'skill.alchemist.name': 'Alchemist',
  'skill.alchemist.desc': 'Consumables are twice as strong, +50% pickup radius, +1 luck.',
  'skill.momentum.name': 'Momentum',
  'skill.momentum.desc': 'Dash recharges faster and grants Might for 3s.',
  'skill.warlock.name': 'Warlock',
  'skill.warlock.desc': 'Effect durations +25%, curses last longer.',
  'skill.bulwark_trait.name': 'Bulwark',
  'skill.bulwark_trait.desc': '+12% max health. Taking damage may grant Fortify.',
  'skill.exploder.name': 'Exploder',
  'skill.exploder.desc': 'Kills have a 25% chance to explode in fire.',
  'skill.executioner.name': 'Executioner',
  'skill.executioner.desc': '+50% crit damage. Crits may make the enemy bleed.',

  // ------------------------------------------------------------ aspects
  'aspect.wail_legion.name': 'Legion of Shades',
  'aspect.wail_legion.desc': 'Five lesser shades instead of two.',
  'aspect.wail_champion.name': 'Champion Shade',
  'aspect.wail_champion.desc': 'One mighty shade that taunts enemies.',
  'aspect.volley_lance.name': 'Lance of Dawn',
  'aspect.volley_lance.desc': 'One enormous lance that pierces everything.',
  'aspect.volley_rain.name': 'Radiant Ring',
  'aspect.volley_rain.desc': 'Twelve arrows in every direction.',
  'aspect.hex_plague.name': 'Plague Hex',
  'aspect.hex_plague.desc': 'Also applies Blight, which spreads on death.',
  'aspect.hex_gravity.name': 'Gravity Hex',
  'aspect.hex_gravity.desc': 'Pulls enemies to the centre and stuns them.',
  'aspect.comet.name': 'Comet',
  'aspect.comet.desc': 'Slow, huge, devastating explosion with heavy Burn.',
  'aspect.ember_swarm.name': 'Ember Swarm',
  'aspect.ember_swarm.desc': 'Six small homing embers.',
  'aspect.glacier.name': 'Glacier',
  'aspect.glacier.desc': 'Leaves a freezing zone for 4s.',
  'aspect.shatter.name': 'Shatter',
  'aspect.shatter.desc': 'Consumes Chill stacks for +60% damage per stack.',
  'aspect.storm.name': 'Storm',
  'aspect.storm.desc': 'A lightning storm zone at the target instead of a chain.',
  'aspect.overload.name': 'Overload',
  'aspect.overload.desc': 'Two jumps, double damage, triple Shock.',
  'aspect.bulwark.name': 'Bulwark',
  'aspect.bulwark.desc': 'Bash also grants a shield and Fortify.',
  'aspect.earthquake.name': 'Earthquake',
  'aspect.earthquake.desc': 'Landing shakes the ground, knocking everything back.',
  'aspect.leech.name': 'Leech',
  'aspect.leech.desc': 'Cheaper rite, +12% lifesteal.',
  'aspect.frenzy.name': 'Frenzy',
  'aspect.frenzy.desc': 'Costs more, grants Might and Haste, +15% attack speed.',
  'aspect.sanctuary.name': 'Sanctuary',
  'aspect.sanctuary.desc': 'A holy zone that heals allies and burns enemies for 6s.',
  'aspect.retribution.name': 'Retribution',
  'aspect.retribution.desc': 'Allies gain Might and Fortify; you gain +30% thorns.',
  'aspect.singularity.name': 'Singularity',
  'aspect.singularity.desc': 'Stronger pull; the rift detonates when cast.',
  'aspect.maw.name': 'Maw',
  'aspect.maw.desc': 'Spawns a void maw that devours for 10s.',
  'aspect.pinning.name': 'Pinning Rain',
  'aspect.pinning.desc': 'Arrows chill their targets.',
  'aspect.poison_rain.name': 'Poison Rain',
  'aspect.poison_rain.desc': 'Wider, longer, blighting rain.',
  'aspect.terror.name': 'Terror',
  'aspect.terror.desc': 'Enemies become Weak and chilled instead.',
  'aspect.rally.name': 'Rally',
  'aspect.rally.desc': 'Allies also regenerate and are healed 20%.',
  'aspect.saw.name': 'Sawblades',
  'aspect.saw.desc': 'Six small bleeding blades.',
  'aspect.guillotine.name': 'Guillotine',
  'aspect.guillotine.desc': 'One huge blade with knockback.',
  'aspect.inferno.name': 'Inferno',
  'aspect.inferno.desc': 'Wider and hotter aura.',
  'aspect.cinders.name': 'Cinders',
  'aspect.cinders.desc': 'Burning kills leave patches of fire.',
  'aspect.hail.name': 'Hail',
  'aspect.hail.desc': 'Eight frost shards fly outward.',
  'aspect.permafrost.name': 'Permafrost',
  'aspect.permafrost.desc': 'Much wider pulse with double Chill.',
  'aspect.twin_bolt.name': 'Twin Bolts',
  'aspect.twin_bolt.desc': 'Two bolts per cast.',
  'aspect.piercer.name': 'Piercer',
  'aspect.piercer.desc': 'One fast bolt that pierces three enemies.',
  'aspect.spiral.name': 'Spiral',
  'aspect.spiral.desc': 'Ten shards in a spiral with more pierce.',
  'aspect.shrapnel.name': 'Shrapnel',
  'aspect.shrapnel.desc': 'Shards burst on impact.',
  'aspect.spores.name': 'Spores',
  'aspect.spores.desc': 'Also plants a spore turret.',
  'aspect.miasma.name': 'Miasma',
  'aspect.miasma.desc': 'Wider cloud that also Weakens.',
  'aspect.healing_totem.name': 'Healing Totem',
  'aspect.healing_totem.desc': 'The totem mends allies instead of shooting.',
  'aspect.thunder_totem.name': 'Thunder Totem',
  'aspect.thunder_totem.desc': 'The totem fires shocking bolts.',
  'aspect.mirror_wall.name': 'Mirror Wall',
  'aspect.mirror_wall.desc': 'Taking damage also grants a brief shield.',
  'aspect.reflection.name': 'Reflection',
  'aspect.reflection.desc': 'Shards fly in all directions; +20% thorns.',

  // ------------------------------------------------------------ keystones
  'keystone.glass_cannon.name': 'Glass Cannon',
  'keystone.glass_cannon.desc': '×1.8 damage, ×0.6 max health.',
  'keystone.mirror.name': 'Mirror',
  'keystone.mirror.desc': 'Reflect 50% of damage taken plus 1% per armor point. Your damage ×0.75, +20 armor.',
  'keystone.legion.name': 'Legion',
  'keystone.legion.desc': '+2 summons, summons ×1.3 power. Your own damage ×0.7.',
  'keystone.lone_wolf.name': 'Lone Wolf',
  'keystone.lone_wolf.desc': 'No summons. +35% crit chance, +50% crit damage.',
  'keystone.blood_for_blood.name': 'Blood for Blood',
  'keystone.blood_for_blood.desc': 'You cannot heal. ×1.3 max health, damage grows up to +90% as health drops.',
  'keystone.frozen_heart.name': 'Frozen Heart',
  'keystone.frozen_heart.desc': 'Every debuff you apply also Chills. Status effects ×1.3, chill stacks shatter.',
  'keystone.ash.name': 'Ash',
  'keystone.ash.desc': 'Everything you kill explodes in fire. +20% area.',
  'keystone.steadfast.name': 'Steadfast',
  'keystone.steadfast.desc': 'You cannot attack with your weapon while moving. ×2 damage, +15 armor.',
  'keystone.shepherd_of_light.name': 'Shepherd of Light',
  'keystone.shepherd_of_light.desc': 'Auras ×2 power, ×1.4 radius, healing ×1.5.',
  'keystone.necromancer.name': 'Necromancer',
  'keystone.necromancer.desc': 'Slain monsters have a 30% chance to rise as your skeletons. Summons ×1.2.',
  'keystone.marauder.name': 'Marauder',
  'keystone.marauder.desc': 'Double loot and consumables, +3 luck, +20% XP. ×0.8 max health.',
  'keystone.acceleration.name': 'Acceleration',
  'keystone.acceleration.desc': '+1 dash charge, +15% speed. Kills reset your dash.',

  // ------------------------------------------------------------ items
  'item.claymore.name': 'Claymore',
  'item.claymore.desc': 'Wide slow sweep with knockback.',
  'item.longbow.name': 'Longbow',
  'item.longbow.desc': 'Fast piercing arrows toward the cursor.',
  'item.staff.name': 'Void Staff',
  'item.staff.desc': 'Slowly homing void bolts.',
  'item.crossbow.name': 'Crossbow',
  'item.crossbow.desc': 'Three piercing bolts per shot.',
  'item.flail.name': 'Flail',
  'item.flail.desc': 'Wide swing that stuns and knocks back.',
  'item.fire_wand.name': 'Fire Wand',
  'item.fire_wand.desc': 'Embers that burst and burn.',
  'item.twin_daggers.name': 'Twin Daggers',
  'item.twin_daggers.desc': 'Very fast short slashes that bleed.',
  'item.frost_staff.name': 'Frost Staff',
  'item.frost_staff.desc': 'Piercing frost bolts that chill.',
  'item.storm_bow.name': 'Storm Bow',
  'item.storm_bow.desc': 'Twin lightning arrows that shock.',
  'item.doom_blade.name': 'Doom Blade',
  'item.doom_blade.desc': 'A great void blade; hits make enemies Vulnerable.',
  'item.chain_mail.name': 'Chain Mail',
  'item.chain_mail.desc': '+12 armor.',
  'item.leather.name': 'Leather Jerkin',
  'item.leather.desc': '+8% speed, +5% crit, +4 armor.',
  'item.robe.name': 'Coven Robe',
  'item.robe.desc': '−12% cooldowns, −5% max health.',
  'item.plate.name': 'Plate Armor',
  'item.plate.desc': '+28 armor, −10% speed.',
  'item.mirror_plate.name': 'Mirror Plate',
  'item.mirror_plate.desc': '+30% thorns, +10 armor.',
  'item.bone_armor.name': 'Bone Armor',
  'item.bone_armor.desc': 'Summons +30% power, +1 summon.',
  'item.ashen_mantle.name': 'Ashen Mantle',
  'item.ashen_mantle.desc': '+15 armor, +25% status effects. Taking damage bursts fire around you.',
  'item.amulet_regen.name': 'Amulet of Renewal',
  'item.amulet_regen.desc': '+2 regen per second, +8% max health.',
  'item.amulet_crit.name': 'Amulet of Precision',
  'item.amulet_crit.desc': '+10% crit chance, +25% crit damage.',
  'item.amulet_greed.name': 'Amulet of Greed',
  'item.amulet_greed.desc': '+2 luck, +12% XP.',
  'item.amulet_haste.name': 'Amulet of Haste',
  'item.amulet_haste.desc': '+15% attack speed, −8% cooldowns.',
  'item.amulet_wrath.name': 'Amulet of Wrath',
  'item.amulet_wrath.desc': '+8% damage. Below 40% health you gain Might and Haste.',
  'item.amulet_summons.name': 'Amulet of the Herd',
  'item.amulet_summons.desc': 'Summons +25% power, +1 summon.',
  'item.amulet_storm.name': 'Amulet of Storms',
  'item.amulet_storm.desc': 'Hits may release chain lightning.',
  'item.amulet_lich.name': 'Lich Amulet',
  'item.amulet_lich.desc': 'Kills may raise a skeleton. Summons +15%.',

  // ------------------------------------------------------------ consumables
  'cons.potion_life.name': 'Potion of Life',
  'cons.potion_life.desc': 'Heal 40% of max health.',
  'cons.elixir_haste.name': 'Elixir of Haste',
  'cons.elixir_haste.desc': 'Haste for 20s.',
  'cons.scroll_choice.name': 'Scroll of Choice',
  'cons.scroll_choice.desc': 'Your next draft offers one more option.',
  'cons.bomb.name': 'Fire Bomb',
  'cons.bomb.desc': 'A big fiery explosion at the cursor.',
  'cons.ward.name': 'Ward',
  'cons.ward.desc': 'A shield worth 30% of your health for 8s.',

  // ------------------------------------------------------------ monsters
  'mob.ghoul.name': 'Ghoul',
  'mob.skeleton_archer.name': 'Skeleton Archer',
  'mob.spore.name': 'Rot Spore',
  'mob.hound.name': 'Grave Hound',
  'mob.bat_swarm.name': 'Bat Swarm',
  'mob.cultist.name': 'Cultist',
  'mob.wraith.name': 'Wraith',
  'mob.bone_knight.name': 'Bone Knight',
  'mob.slime.name': 'Rot Slime',
  'mob.slimelet.name': 'Slimelet',
  'mob.drowned.name': 'Drowned',
  'mob.ash_guard.name': 'Ash Guard',
  'mob.rot_priest.name': 'Rot Priest',
  'mob.storm_wraith.name': 'Storm Wraith',
  'mob.ash_knight.name': 'Ash Knight',
  'mob.rot_mother.name': 'Rot Mother',
  'mob.drowned_king.name': 'Drowned King',
  'mob.shade.name': 'Shade',
  'mob.shade_lesser.name': 'Lesser Shade',
  'mob.shade_champion.name': 'Champion Shade',
  'mob.totem.name': 'Guardian Totem',
  'mob.healing_totem.name': 'Healing Totem',
  'mob.thunder_totem.name': 'Thunder Totem',
  'mob.spore_turret.name': 'Spore Turret',
  'mob.void_maw.name': 'Void Maw',
  'mob.skeleton.name': 'Skeleton',
  'mob.unknown.name': 'the unknown',
  'mob.player.name': 'a player',

  // ------------------------------------------------------------ statuses & affixes
  'status.burn.name': 'Burn',
  'status.chill.name': 'Chill',
  'status.shock.name': 'Shock',
  'status.blight.name': 'Blight',
  'status.bleed.name': 'Bleed',
  'status.vulnerable.name': 'Vulnerable',
  'status.weak.name': 'Weak',
  'status.haste.name': 'Haste',
  'status.might.name': 'Might',
  'status.fortify.name': 'Fortify',
  'status.regen.name': 'Regen',
  'status.shield.name': 'Shield',
  'status.taunt.name': 'Taunt',
  'status.stun.name': 'Stun',
  'status.invuln.name': 'Invulnerable',
  'affix.swift.name': 'Swift',
  'affix.armored.name': 'Armored',
  'affix.toxic.name': 'Toxic',
  'affix.shielded.name': 'Shielded',
  'affix.vampiric.name': 'Vampiric',
  'affix.burning.name': 'Burning',
  'affix.frost.name': 'Frost',
  'affix.berserk.name': 'Berserk',
  'affix.explosive.name': 'Explosive',

  // ------------------------------------------------------------ stats
  'stat.armor': 'Armor',
  'stat.dmg': 'Damage',
  'stat.spd': 'Speed',
  'stat.crit': 'Crit',
  'stat.aspd': 'Attack speed',
  'stat.cdr': 'Cooldowns',
  'stat.area': 'Area',
  'stat.thorns': 'Thorns',
  'stat.ls': 'Lifesteal',
  'stat.luck': 'Luck',
  'stat.regen': 'Regen',
  'stat.maxHp': 'Max health',
  'stat.hpRegen': 'Regen',
  'stat.damage': 'Damage',
  'stat.attackSpeed': 'Attack speed',
  'stat.moveSpeed': 'Speed',
  'stat.critChance': 'Crit chance',
  'stat.critMult': 'Crit damage',
  'stat.cooldown': 'Cooldowns',
  'stat.projSpeed': 'Projectile speed',
  'stat.projCount': 'Projectiles',
  'stat.pierce': 'Pierce',
  'stat.range': 'Range',
  'stat.lifesteal': 'Lifesteal',
  'stat.summonCount': 'Summons',
  'stat.summonPower': 'Summon power',
  'stat.auraPower': 'Aura power',
  'stat.auraRadius': 'Aura radius',
  'stat.healPower': 'Healing',
  'stat.xpGain': 'XP gain',
  'stat.dashCharges': 'Dash charges',
  'stat.dashCooldown': 'Dash recharge',
  'stat.statusPower': 'Status effects',
  'stat.duration': 'Durations',
  'stat.pickupRadius': 'Pickup radius',

  // ------------------------------------------------------------ pets
  'btn.pets': 'Companions',
  'btn.select': 'Take along',
  'btn.unequip': 'Leave at home',
  'btn.unlock': 'Adopt for {cost} fame',
  'label.pet': 'Companion',
  'label.free': 'free',
  'label.petsHint': 'One companion follows you into every realm. They cannot die and grow up to level 10 from your runs.',
  'label.petsDuelNote': 'Companions stay home during duels so both sides fight on equal terms.',
  'toast.petUnlocked': '{name} joins you.',
  'toast.notEnoughFame': 'Not enough fame yet. Realms and bosses grant fame.',
  'pet.wolf.name': 'Grave Pup',
  'pet.wolf.desc': 'A young wolf that bites enemies near you. +2% damage.',
  'pet.raven.name': 'Raven',
  'pet.raven.desc': 'Spots loot from afar: pickup radius +60%, XP +6%, +1 luck.',
  'pet.wisp.name': 'Wisp',
  'pet.wisp.desc': 'A light that mends you a little every few seconds. Healing +8%.',
  'pet.tortoise.name': 'Grave Tortoise',
  'pet.tortoise.desc': 'When you take a hit, shields you for a moment. +5 armor.',
  'pet.bat.name': 'Bat',
  'pet.bat.desc': 'Feeds on the fallen: +2% lifesteal, kills may heal you.',
  'pet.cat.name': 'Void Kitten',
  'pet.cat.desc': 'Hisses homing void bolts at enemies. Cooldowns −3%.',

  // ------------------------------------------------------------ hero slots
  'label.heroes': 'Heroes',
  'label.slot': 'Slot {n}',
  'label.emptySlot': 'Empty slot',
  'label.lockedSlot': 'Locked slot',
  'btn.newHero': 'New hero',
  'btn.continueHero': 'Continue',
  'btn.unlockSlot': 'Unlock for {cost} fame',
  'btn.abandon': 'Abandon',
  'confirm.abandon': 'Abandon {name} (rank {rank})? The hero and all gear are lost for good.',
  'label.heroesHint': 'Leave a realm alive and the hero waits here with rank, kit and gear. Level, blessings and keystones belong to the realm. Death frees the slot.',
  'label.slotsShop': 'More slots will be sold in the shop; for now they cost fame.',
  'btn.leaveSave': 'Leave realm · hero is kept',
  'label.slotFreed': 'The slot is free again: a new hero can take it.',
  'label.runs': 'Runs',
  'label.playedTime': 'Time in realms',
  'toast.slotUnlocked': 'A new hero slot is yours.',
  'toast.slotsMaxed': 'All slots are already unlocked.',
  'toast.heroInRealm': 'This hero is in a realm right now.',

  // ------------------------------------------------------------ hero tree
  'label.heroTree': 'Hero tree',
  'label.locked': 'Locked',
  'label.unlockNeeds': 'Unlocks at',
  'label.tier0': 'Founders',
  'label.tier1': 'Crossings',
  'label.tier2': 'Deep paths',
  'label.tier3': 'The Crown',
  'label.bestLevel': 'best rank',
  'label.heroLockedHint': 'Reach these ranks with the parent heroes. Rank is kept even when a hero falls.',
  'toast.heroUnlocked': 'New hero unlocked: {name}',
  'hero.warden.name': 'Warden',
  'hero.warden.desc': 'A knight who swore to hold the line. Halberd sweeps, oaths that harden his skin and weaken everyone around him. Leans toward defense, self-buffs and debuffs.',
  'hero.warden.trait': 'Sentinel',
  'hero.warden.traitDesc': '+15 armor, 10% thorns. Taking a hit has a chance to weaken nearby enemies.',
  'hero.mystic.name': 'Mystic',
  'hero.mystic.desc': 'A summoner who bargains with demons and coaxes thorns out of dead soil. Temporary imps, fiends and hungry plants; every summoning frightens foes. Leans toward summons and debuffs.',
  'hero.mystic.trait': 'Demonologist',
  'hero.mystic.traitDesc': '+20% summon power, +15% durations. Summoning weakens enemies around you.',
  'hero.leomorph.name': 'Leomorph',
  'hero.leomorph.desc': 'Half man, half tiger, all appetite. Enormous health, claws that bleed, and forms that turn him into a beast for a while. Leans toward health, bleeding and mobility.',
  'hero.leomorph.trait': 'Feral Vigor',
  'hero.leomorph.traitDesc': '+25% max health, +1.5 regen per second, 3% lifesteal.',
  'hero.druid.name': 'Druid',
  'hero.druid.desc': 'Keeper of the old groves. Calls a bonded beast that fights beside you for as long as it lives, and mends allies when the hunt goes well. Leans toward summons and healing.',
  'hero.druid.trait': 'Wild Bond',
  'hero.druid.traitDesc': '+30% summon power, +20% healing. Kills have a chance to heal nearby allies.',
  'hero.shaman.name': 'Shaman',
  'hero.shaman.desc': 'Speaks with fire, frost and storm in turn. Switches attunements that lend their element to every shot and rewards every switch with fury. Leans toward elemental damage.',
  'hero.shaman.trait': 'Spirit Flow',
  'hero.shaman.traitDesc': '+10% damage. Elemental casts grant Might for 3 s.',
  'hero.goblins.name': 'Goblin Trio',
  'hero.goblins.desc': 'Three goblins, one hero. Their dark-magic contraptions hold ground: turrets, traps and a sparkgun at middle range. Leans toward summons, projectiles and positioning.',
  'hero.goblins.trait': 'Tinkerers',
  'hero.goblins.traitDesc': '+1 summon, +1 luck, +15% projectile speed. Kills sometimes drop a spare turret.',
  'hero.bard.name': 'Bard',
  'hero.bard.desc': 'A wanderer whose songs mend and rally. Lute shots at bow-like range, chords that cleanse allies and lift them. Leans toward buffs, cleansing and support.',
  'hero.bard.trait': 'Encore',
  'hero.bard.traitDesc': 'Durations +30%, aura radius +30%, healing +15%. Aura casts grant allies Regeneration.',
  'skill.bulwark_oath.name': 'Bulwark Oath',
  'skill.bulwark_oath.desc': 'Fortify and shield yourself; enemies around you are weakened and forced to attack you.',
  'aspect.oath_iron.name': 'Iron Oath',
  'aspect.oath_iron.desc': 'Longer fortify, stronger shield, +30% thorns.',
  'aspect.oath_dread.name': 'Dread Oath',
  'aspect.oath_dread.desc': 'Wider: enemies are also made vulnerable.',
  'skill.spirit_pact.name': 'Spirit Pact',
  'skill.spirit_pact.desc': 'Two imps answer the call for {dur} s, spitting void that leaves foes vulnerable.',
  'aspect.pact_swarm.name': 'Imp Swarm',
  'aspect.pact_swarm.desc': 'Five lesser imps.',
  'aspect.pact_fiend.name': 'Fiend',
  'aspect.pact_fiend.desc': 'One fiend at the aim point that terrifies enemies.',
  'skill.thornroot.name': 'Thornroot',
  'skill.thornroot.desc': 'Grow a thorny root at the aim point: it lashes, blights and chills anything near.',
  'aspect.root_grove.name': 'Grove',
  'aspect.root_grove.desc': 'Three roots, shorter lived.',
  'aspect.root_bloom.name': 'Bloomroot',
  'aspect.root_bloom.desc': 'A flowering root that also heals allies.',
  'skill.tiger_form.name': 'Tiger Form',
  'skill.tiger_form.desc': 'Become the tiger for {dur} s: faster, harder hitting, and heal 12%.',
  'aspect.form_bear.name': 'Bear Form',
  'aspect.form_bear.desc': 'Armor, damage taken −20%, regeneration and a 20% heal instead.',
  'aspect.form_stalker.name': 'Stalker',
  'aspect.form_stalker.desc': 'Tiger form with haste, opening with a bleeding pounce.',
  'skill.kindred_beast.name': 'Kindred Beast',
  'skill.kindred_beast.desc': 'A bear companion that fights beside you for {dur}s. Recast to heal it. Evolves into a dragon, a trio of bears or an armoured bear.',
  'aspect.kindred_pack.name': 'Kindred Pack',
  'aspect.kindred_pack.desc': 'Two wolves instead of the bear.',
  'aspect.kindred_ancient.name': 'Ancient',
  'aspect.kindred_ancient.desc': 'A huge old bear that roars to draw enemies.',
  'skill.attunement.name': 'Attunement',
  'skill.attunement.desc': 'Cycle fire → frost → storm. Your weapon hits carry the current element.',
  'aspect.attune_fury.name': 'Fury',
  'aspect.attune_fury.desc': 'Each switch also bursts in a nova of all three elements.',
  'aspect.attune_focus.name': 'Focus',
  'aspect.attune_focus.desc': '+15% damage, +20% projectile speed.',
  'skill.turret.name': 'Turret',
  'skill.turret.desc': 'Deploy a void turret at the aim point for {dur} s.',
  'aspect.turret_twin.name': 'Twin Turrets',
  'aspect.turret_twin.desc': 'Two turrets, shorter lived.',
  'aspect.turret_cannon.name': 'Cannon',
  'aspect.turret_cannon.desc': 'A slow heavy cannon that leaves foes vulnerable.',
  'skill.snare_trap.name': 'Snare Trap',
  'skill.snare_trap.desc': 'Lay a void trap: enemies inside are chilled, vulnerable and hurt every second.',
  'aspect.trap_shock.name': 'Shock Trap',
  'aspect.trap_shock.desc': 'Lightning: shocks and briefly stuns.',
  'aspect.trap_maw.name': 'Maw Trap',
  'aspect.trap_maw.desc': 'Pulls enemies toward its centre.',
  'skill.rallying_chord.name': 'Rallying Chord',
  'skill.rallying_chord.desc': 'Cleanse allies nearby of debuffs and inspire them: +15% damage, +10% speed.',
  'aspect.chord_march.name': 'March',
  'aspect.chord_march.desc': 'Also grants Haste.',
  'aspect.chord_hymn.name': 'Hymn',
  'aspect.chord_hymn.desc': 'Also heals allies.',
  'item.halberd.name': 'Halberd',
  'item.halberd.desc': 'Long sweeping reach; hits weaken.',
  'item.soul_orb.name': 'Soul Orb',
  'item.soul_orb.desc': 'Homing void bolts.',
  'item.claws.name': 'Claws',
  'item.claws.desc': 'Fast short slashes that bleed.',
  'item.sickle.name': 'Sickle',
  'item.sickle.desc': 'Wide harvesting arc.',
  'item.totem_staff.name': 'Totem Staff',
  'item.totem_staff.desc': 'Quick bolts that take your attunement.',
  'item.sparkgun.name': 'Sparkgun',
  'item.sparkgun.desc': 'Rapid mid-range sparks.',
  'item.lute.name': 'Lute',
  'item.lute.desc': 'Notes that fly almost as far as arrows.',
  'mob.imp.name': 'Imp',
  'mob.imp_lesser.name': 'Lesser Imp',
  'mob.fiend.name': 'Fiend',
  'mob.thornroot.name': 'Thornroot',
  'mob.bloomroot.name': 'Bloomroot',
  'mob.kindred_bear.name': 'Kindred Bear',
  'mob.kindred_wolf.name': 'Kindred Wolf',
  'mob.kindred_ancient.name': 'Ancient Bear',
  'mob.gob_turret.name': 'Goblin Turret',
  'mob.gob_cannon.name': 'Goblin Cannon',
  'status.tiger.name': 'Tiger Form',
  'status.bear.name': 'Bear Form',
  'status.attune_fire.name': 'Fire Attunement',
  'status.attune_frost.name': 'Frost Attunement',
  'status.attune_storm.name': 'Storm Attunement',
  'status.inspire.name': 'Inspired',

  // ------------------------------------------------------------ owner console
  'announce.custom': '{text}',
  'feed.custom': '{text}',
  'admin.title': 'Admin console',
  'admin.on': 'admin',
  'admin.off': 'locked',
  'admin.accountId': 'Account id',
  'admin.copy': 'Copy',
  'admin.password': 'Password',
  'admin.login': 'Unlock',
  'admin.hint': 'Opens only for accounts listed in ADMIN_ACCOUNTS on the server, with ADMIN_PASSWORD. F8 toggles this panel.',
  'admin.tab.self': 'Self',
  'admin.tab.give': 'Give',
  'admin.tab.world': 'World',
  'admin.tab.players': 'Players',
  'admin.tab.account': 'Account',
  'admin.target': 'Target',
  'admin.me': 'me',
  'admin.needGame': 'Enter a realm to use world and hero commands.',
  'admin.godOn': 'God on',
  'admin.godOff': 'God off',
  'admin.heal': 'Heal',
  'admin.slay': 'Slay',
  'admin.setLevel': 'Set level',
  'admin.cheats': 'Stat cheats',
  'admin.reset': 'Reset',
  'admin.cheat.speed': 'Speed ×2',
  'admin.cheat.damage': 'Damage ×5',
  'admin.cheat.cooldown': 'Cooldowns −90%',
  'admin.cheat.aspd': 'Attack speed ×3',
  'admin.cheat.area': 'Area ×2',
  'admin.cheat.summons': '+5 summons, ×2 power',
  'admin.cheat.tank': 'HP ×5, +200 armor',
  'admin.cheat.luck': '+10 luck, XP ×5',
  'admin.give': 'Give',
  'admin.mobs': 'mobs',
  'admin.elite': 'elite',
  'admin.spawn': 'Spawn at cursor',
  'admin.boss': 'Summon boss',
  'admin.killAll': 'Kill all',
  'admin.clear': 'Clear mobs',
  'admin.refresh': 'Refresh',
  'admin.set': 'Set',
  'admin.announceText': 'Announcement text',
  'admin.announce': 'Announce',
  'admin.sayAs': 'Say as this player',
  'admin.sayAsPick': 'speak as…',
  'admin.sayText': 'Message',
  'admin.say': 'Say',
  'admin.pull': 'Pull to me',
  'admin.kick': 'Kick',
  'admin.allHeroes': 'All heroes',
  'admin.unlock': 'Unlock',
  'admin.setSlots': 'Set slots',
  'admin.offlineNote': 'Offline: fame and slots live on the server only.',
  'toast.backBlocked': 'Back is disabled inside the realm. Press Esc and choose Leave to exit.',
  // ------------------------------------------------------------ rank & level, kit, blessings
  'label.rarity3': 'Legendary',
  'label.levelBar': 'Realm level: skill ranks and blessings for this realm only',
  'label.rankBar': 'Rank: kept between realms, buys the kit',
  'label.rankTrack': 'Rank',
  'label.rankShort': 'Rk.',
  'label.pts': 'pts',
  'label.pointsHint': 'Unspent rank points: open the build panel (Tab)',
  'label.pointsFree': '{n} of {total} points free',
  'label.rankHint': 'Each rank gives one point. Skill 1 · first aspect 2 · second aspect 3 · trait rank 1. The same experience fills level (fast, burns with the realm) and rank (slow, stays).',
  'label.tab.kit': 'Kit',
  'label.tab.gear': 'Gear',
  'label.tab.stats': 'Stats',
  'label.kitPool': 'Hero pool',
  'label.kitPoolHint': 'Unlock a skill from your hero\'s pool for {cost} point. Up to 4 actives and 3 autos.',
  'label.activeShort': 'active',
  'label.autoShort': 'auto',
  'label.autoCast': 'auto',
  'label.autoCastHint': 'Cast on cooldown at the nearest enemy',
  'label.ring1': 'First aspect',
  'label.ring2': 'Second aspect',
  'label.costPoints': 'Costs {n} rank points',
  'label.blessing': 'Blessing',
  'label.blessings': 'Realm blessings',
  'label.blessingsHint': 'Random gifts of this realm. They burn when you leave.',
  'label.equipped': 'Worn',
  'label.backpack': 'Backpack',
  'label.backpackHint': 'Items you carry but do not wear. Lost with the hero; leave the realm alive to stash them in the vault.',
  'label.respecFree': 'Respec is free below rank {rank}.',
  'label.respecCost': 'Respec costs {fame} fame.',
  'btn.respec': 'Respec',
  'confirm.respecFree': 'Return every rank point? The kit resets to the signature skill.',
  'confirm.respecPaid': 'Return every rank point for {fame} fame? The kit resets to the signature skill.',
  'btn.equip': 'Equip',
  'btn.drop': 'Drop on the ground',
  'label.targetDead': 'The hero has fallen…',
  'label.martyr': 'The crowd had a hand in this death. Martyr\'s fame added.',
  'btn.showLink': 'Show link',
  'label.showLinkHint': 'Copy a link that lets others watch this run',
  'announce.rankUp': 'Rank {rank}! A new point to spend.',
  'feed.legendary': '{name} found a legendary: {item}!',
  'feed.relicDrop': 'The revenant of {name} left its relic to {killer}: {item}',
  'build.notInPool': 'That skill is not in this hero\'s pool',
  'build.owned': 'Already in the kit',
  'build.noPoints': 'Not enough rank points',
  'build.activesFull': 'All four active slots are taken',
  'build.autosFull': 'All three auto slots are taken',
  'build.notOwned': 'The skill is not in the kit',
  'build.pathFull': 'Both aspects are already chosen',
  'build.badAspect': 'That aspect is not available here',
  'build.maxed': 'Already at max rank',
  'build.noItem': 'No such item',
  'build.noFame': 'Not enough fame for a respec',
  'admin.setRank': 'Set rank',

  // ------------------------------------------------------------ show mode
  'label.watchingName': 'Watching {name}',
  'btn.stopWatching': 'Stop watching',
  'label.crowdTitle': 'The crowd',
  'label.crowdOff': '{name} has not enabled show mode. You can watch, not interfere.',
  'label.crowdHint': 'Spend fame to help or torment the hero. Half of it goes to them.',
  'label.crowdHarm': 'Torment',
  'label.crowdHelp': 'Help',
  'label.crowdCooldown': 'Next purchase in {s}s',
  'label.crowdReady': 'Pick an effect',
  'label.priceFame': 'Price: {n} fame',
  'toast.watchClosed': 'The realm has closed.',
  'toast.watchEnded': 'The show is over: the hero left the realm.',
  'announce.crowdHarm': '{by} unleashed {effect} on you!',
  'announce.crowdHelp': '{by} sent {effect}',
  'feed.crowdHarm': '{by} tormented {target}: {effect}',
  'feed.crowdHelp': '{by} helped {target}: {effect}',
  'feed.watching': '{name} is watching {target}',
  'label.findPlayer': 'Nickname…',
  'label.findPlayerTitle': 'Find a player',
  'btn.find': 'Find',
  'label.playerHidden': 'This player hides their whereabouts',
  'label.inRealmCode': 'in realm {code}',
  'label.showModeOn': 'show mode',
  'btn.watch': 'Watch',
  'btn.joinRealm': 'Join their realm',
  'toast.playerNotFound': 'No player with that nickname',
  'toast.playerHidden': 'This player hides their whereabouts',
  'toast.notInRealm': 'This player is not in a realm right now',
  'label.watchHint': 'Watch a friend\'s run: find them by nickname.',
  'label.showMode': 'Show mode',
  'label.visibility': 'Who sees where I am',
  'label.visibilityHint': 'Nickname lookups reveal your realm, hero and rank',
  'label.vis.public': 'Everyone',
  'label.vis.guild': 'Guild only',
  'label.vis.hidden': 'Nobody',
  'label.showModeToggle': 'Let the crowd interfere',
  'label.showModeHint': 'Spectators may spend fame to help or torment your hero. You keep half of what they spend, and a death by the crowd pays martyr\'s fame.',
  'label.showLink': 'Your show link',
  'toast.nameReserved': 'That name is reserved for staff',
  'toast.nameProfane': 'That name is not allowed',
  'crowd.unknown': 'Unknown effect',
  'crowd.noTarget': 'The hero is gone',
  'crowd.notShow': 'The hero has not enabled show mode',
  'crowd.cooldown': 'Too soon: wait a moment',
  'crowd.budget': 'The crowd has done enough this minute',
  'crowd.grace': 'The hero has just arrived; give them a moment',
  'crowd.offline': 'Only on the server',
  'crowd.noFame': 'Not enough fame',
  'crowd.notRealm': 'Not in a realm',
  'crowd.bossAlready': 'The boss is already here',
  'crowd.noGhosts': 'No revenants remember this realm',
  'crowd.noRoom': 'No room to appear',
  'crowd.bagFull': 'The hero\'s bag is full',

  // ------------------------------------------------------------ vault
  'label.vault': 'Vault',
  'label.vaultHint': 'Items in the vault are safe. A resting hero can take them into its backpack or stash what it brought back. Salvage turns items into fame.',
  'label.vaultItems': 'In the vault',
  'btn.takeToBag': 'To bag',
  'btn.salvage': 'Salvage',
  'btn.salvageFor': 'Salvage for {fame} fame',
  'confirm.salvage': 'Break {name} down for {fame} fame?',
  'btn.vaultSlots': '+4 slots for {cost} fame',
  'label.heroBag': 'Hero backpack',
  'label.noHeroes': 'No living heroes yet',
  'label.pickHeroFirst': 'Pick a hero first',
  'toast.vaultFull': 'The vault is full',
  'toast.bagFull': 'The backpack is full',

  // ------------------------------------------------------------ druid skills
  'skill.walking_tree.name': 'Walking Tree',
  'skill.walking_tree.desc': 'Wake a treant that stomps beside you for {dur}s. Recast to mend it.',
  'skill.vine.name': 'Vine',
  'skill.vine.desc': 'Plant a lashing vine at the aim point for {dur} s: it chills and whips whatever comes near.',
  'skill.flytrap.name': 'Flytrap',
  'skill.flytrap.desc': 'Grow a hungry flytrap at the aim point for {dur} s: it drags enemies in and bites hard.',

  // ------------------------------------------------------------ aspects: ring one
  'aspect.shaggy_dragon.name': 'Shaggy Dragon',
  'aspect.shaggy_dragon.desc': 'The bear becomes a shaggy dragon that hovers behind you breathing fire.',
  'aspect.three_bears.name': 'Three Bears',
  'aspect.three_bears.desc': 'Three lesser bears instead of one.',
  'aspect.armored_bear.name': 'Armoured Bear',
  'aspect.armored_bear.desc': 'A slow bear in plate that roars enemies onto itself.',
  'aspect.ram_tree.name': 'Battering Tree',
  'aspect.ram_tree.desc': 'The treant charges into packs.',
  'aspect.healer_tree.name': 'Healing Tree',
  'aspect.healer_tree.desc': 'The treant mends allies around it.',
  'aspect.fortress_tree.name': 'Fortress Tree',
  'aspect.fortress_tree.desc': 'A huge treant that taunts everything nearby.',
  'aspect.snare_vine.name': 'Snaring Vine',
  'aspect.snare_vine.desc': 'Heavier chill and brief stuns instead of damage.',
  'aspect.whip_vine.name': 'Whipping Vine',
  'aspect.whip_vine.desc': 'Fast slashing lashes.',
  'aspect.shield_vine.name': 'Sheltering Vine',
  'aspect.shield_vine.desc': 'A vine that heals allies near it.',
  'aspect.devourer.name': 'Devourer',
  'aspect.devourer.desc': 'A bigger maw with a much harder bite.',
  'aspect.venom_bush.name': 'Venom Bush',
  'aspect.venom_bush.desc': 'A bush that puffs blighting spores in all directions.',
  'aspect.lure_trap.name': 'Lure',
  'aspect.lure_trap.desc': 'A sturdy plant that taunts enemies to itself.',
  'aspect.wail_dirge.name': 'Dirge',
  'aspect.wail_dirge.desc': 'Two wailing shades that shoot void from afar.',
  'aspect.volley_mercy.name': 'Volley of Mercy',
  'aspect.volley_mercy.desc': 'Four arrows; each hit heals your most wounded ally.',
  'aspect.hex_dread.name': 'Dread Hex',
  'aspect.hex_dread.desc': 'A wider terror: Weak and Vulnerable for 6 s.',
  'aspect.oath_valor.name': 'Oath of Valour',
  'aspect.oath_valor.desc': 'Might and Haste instead of the shield; enemies are still taunted.',
  'aspect.pact_wraith.name': 'Wraith Pact',
  'aspect.pact_wraith.desc': 'One blinking wraith that fires twin bolts.',
  'aspect.form_lion.name': 'Lion Form',
  'aspect.form_lion.desc': 'Might for 5 s and a roar that taunts.',
  'aspect.attune_twin.name': 'Twin Spirits',
  'aspect.attune_twin.desc': '+1 projectile, −10% damage.',
  'aspect.turret_tesla.name': 'Tesla Coil',
  'aspect.turret_tesla.desc': 'A coil that arcs lightning between enemies.',
  'aspect.chord_war.name': 'War Chord',
  'aspect.chord_war.desc': 'Allies also gain Might.',
  'aspect.fireball_wildfire.name': 'Wildfire',
  'aspect.fireball_wildfire.desc': 'Three smaller fireballs that leave burning ground.',
  'aspect.nova_permafrost.name': 'Deep Freeze',
  'aspect.nova_permafrost.desc': 'Full Chill and a brief stun; longer cooldown.',
  'aspect.chain_static.name': 'Static',
  'aspect.chain_static.desc': 'Six jumps with double Shock.',
  'aspect.bash_thunder.name': 'Thunder Bash',
  'aspect.bash_thunder.desc': 'Longer lunge that shocks and stuns.',
  'aspect.rite_offering.name': 'Offering',
  'aspect.rite_offering.desc': 'Bleed more to heal allies and grant them Might.',
  'aspect.ward_bastion.name': 'Bastion',
  'aspect.ward_bastion.desc': 'Stronger shield and Fortify for allies.',
  'aspect.rift_collapse.name': 'Collapse',
  'aspect.rift_collapse.desc': 'One violent implosion instead of a lingering rift.',
  'aspect.storm_barrage.name': 'Barrage',
  'aspect.storm_barrage.desc': 'Shorter, denser rain.',
  'aspect.cry_dirge.name': 'Grim Cry',
  'aspect.cry_dirge.desc': 'Allies regenerate and harden; enemies are weakened.',
  'aspect.blades_frost.name': 'Frost Blades',
  'aspect.blades_frost.desc': 'Three chilling blades.',
  'aspect.aura_hellfire.name': 'Hellfire',
  'aspect.aura_hellfire.desc': 'Smaller but far hotter aura.',
  'aspect.pulse_glacier.name': 'Glacier Pulse',
  'aspect.pulse_glacier.desc': 'Wider pulse with double Chill.',
  'aspect.bolt_seeker.name': 'Seekers',
  'aspect.bolt_seeker.desc': 'Two strongly homing bolts.',
  'aspect.shards_wall.name': 'Bone Wall',
  'aspect.shards_wall.desc': 'Nine short shards in a tight ring.',
  'aspect.cloud_spores.name': 'Spore Cloud',
  'aspect.cloud_spores.desc': 'Wider cloud that also Weakens.',
  'aspect.totem_storm.name': 'Storm Totem',
  'aspect.totem_storm.desc': 'A totem that fires shocking bolts.',
  'aspect.shards_prism.name': 'Prism',
  'aspect.shards_prism.desc': 'Five homing shards.',
  'aspect.root_strangler.name': 'Strangler',
  'aspect.root_strangler.desc': 'A root that pulls and bleeds.',
  'aspect.trap_bloom.name': 'Blooming Trap',
  'aspect.trap_bloom.desc': 'A long-lived trap that also heals allies inside.',

  // ------------------------------------------------------------ aspects: ring two
  'aspect.plague_dragon.name': 'Plague Dragon',
  'aspect.plague_dragon.desc': 'Breathes blighting spores that weaken.',
  'aspect.chaos_serpent.name': 'Serpent of Chaos',
  'aspect.chaos_serpent.desc': 'A shaggy serpent that rams and stuns.',
  'aspect.bonded_dragon.name': 'Bonded Dragon',
  'aspect.bonded_dragon.desc': 'Permanent. 90% of the damage you take is taken by the dragon instead.',
  'aspect.bear_ring.name': 'Ring of Bears',
  'aspect.bear_ring.desc': 'The bears hold a ring around you and soak part of every hit.',
  'aspect.bear_pack.name': 'Bear Pack',
  'aspect.bear_pack.desc': 'Fast bears that pounce and bleed.',
  'aspect.mother_bear.name': 'Mother Bear',
  'aspect.mother_bear.desc': 'A great mother with two cubs that lick your wounds.',
  'aspect.banner_bear.name': 'Banner Bear',
  'aspect.banner_bear.desc': 'Its banner fortifies allies around it.',
  'aspect.crusher_bear.name': 'Crusher',
  'aspect.crusher_bear.desc': 'Slow, brutal blows.',
  'aspect.loyal_bear.name': 'Loyal Bear',
  'aspect.loyal_bear.desc': 'Permanent companion; summons +15%.',
  'aspect.thorn_ram.name': 'Thorn Ram',
  'aspect.thorn_ram.desc': 'Charges leave deep bleeding.',
  'aspect.rootquake.name': 'Rootquake',
  'aspect.rootquake.desc': 'Charges stun in a wide arc; stomps knock back.',
  'aspect.twin_rams.name': 'Twin Rams',
  'aspect.twin_rams.desc': 'Two smaller battering treants.',
  'aspect.sap_tree.name': 'Sap Tree',
  'aspect.sap_tree.desc': 'Also grants Regeneration.',
  'aspect.bark_tree.name': 'Bark Tree',
  'aspect.bark_tree.desc': 'Tougher; also grants Fortify.',
  'aspect.elder_tree.name': 'Elder Tree',
  'aspect.elder_tree.desc': 'Huge, long-lived, heals farther and taunts.',
  'aspect.hollow_fortress.name': 'Hollow Fortress',
  'aspect.hollow_fortress.desc': 'Shelters allies with Fortify and Regeneration.',
  'aspect.burning_fortress.name': 'Burning Fortress',
  'aspect.burning_fortress.desc': 'Sheds embers that burn everything close.',
  'aspect.walking_wall.name': 'Walking Wall',
  'aspect.walking_wall.desc': 'Two lesser fortress trees.',
  'aspect.thorn_net.name': 'Thorn Net',
  'aspect.thorn_net.desc': 'Snares also bleed.',
  'aspect.frost_net.name': 'Frost Net',
  'aspect.frost_net.desc': 'Wider, with full Chill.',
  'aspect.grasping_net.name': 'Grasping Net',
  'aspect.grasping_net.desc': 'Pulls enemies toward the vine.',
  'aspect.venom_whip.name': 'Venom Whip',
  'aspect.venom_whip.desc': 'Lashes blight.',
  'aspect.twin_whips.name': 'Twin Whips',
  'aspect.twin_whips.desc': 'Two whipping vines.',
  'aspect.long_whip.name': 'Long Whip',
  'aspect.long_whip.desc': 'Much longer reach.',
  'aspect.barrier_vine.name': 'Barrier Vine',
  'aspect.barrier_vine.desc': 'Shields allies nearby instead of healing.',
  'aspect.mending_vine.name': 'Mending Vine',
  'aspect.mending_vine.desc': 'Stronger heals and Regeneration.',
  'aspect.living_wall.name': 'Living Wall',
  'aspect.living_wall.desc': 'Two tough vines that taunt.',
  'aspect.acid_maw.name': 'Acid Maw',
  'aspect.acid_maw.desc': 'Spits blight at range.',
  'aspect.giant_maw.name': 'Giant Maw',
  'aspect.giant_maw.desc': 'Enormous, devastating and long-lived.',
  'aspect.swift_maw.name': 'Swift Maw',
  'aspect.swift_maw.desc': 'Bites twice as often.',
  'aspect.spore_cloud.name': 'Spore Storm',
  'aspect.spore_cloud.desc': 'Ten spores, farther.',
  'aspect.paralytic_spores.name': 'Numbing Spores',
  'aspect.paralytic_spores.desc': 'Spores chill and briefly stun.',
  'aspect.twin_bushes.name': 'Twin Bushes',
  'aspect.twin_bushes.desc': 'Two venom bushes.',
  'aspect.sticky_lure.name': 'Sticky Lure',
  'aspect.sticky_lure.desc': 'Taunted enemies are also chilled.',
  'aspect.bright_lure.name': 'Bright Lure',
  'aspect.bright_lure.desc': 'Taunts from far away.',
  'aspect.thorned_lure.name': 'Thorned Lure',
  'aspect.thorned_lure.desc': 'Reflects the damage it takes.',
  'aspect.legion_swarm.name': 'Swarm',
  'aspect.legion_swarm.desc': 'Eight shades, briefly.',
  'aspect.legion_shield.name': 'Shielded Legion',
  'aspect.legion_shield.desc': 'Shades inherit your armour; summons +20%.',
  'aspect.legion_haunt.name': 'Haunting Legion',
  'aspect.legion_haunt.desc': 'Haunters that weaken foes.',
  'aspect.champion_knight.name': 'Shade Knight',
  'aspect.champion_knight.desc': 'An armoured shade that taunts.',
  'aspect.champion_reaper.name': 'Shade Reaper',
  'aspect.champion_reaper.desc': 'Faster, deadlier, frailer.',
  'aspect.champion_bond.name': 'Bound Champion',
  'aspect.champion_bond.desc': 'Permanent. 90% of the damage you take falls on the champion.',
  'aspect.dirge_choir.name': 'Choir',
  'aspect.dirge_choir.desc': 'Three wailers.',
  'aspect.dirge_curse.name': 'Cursing Dirge',
  'aspect.dirge_curse.desc': 'Wails leave foes Vulnerable.',
  'aspect.dirge_echo.name': 'Echo',
  'aspect.dirge_echo.desc': 'Short-lived, cast far more often.',
  'aspect.lance_sun.name': 'Sunlance',
  'aspect.lance_sun.desc': 'Bigger and much heavier.',
  'aspect.lance_twin.name': 'Twin Lances',
  'aspect.lance_twin.desc': 'Two lances.',
  'aspect.lance_smite.name': 'Smiting Lance',
  'aspect.lance_smite.desc': 'Leaves foes Vulnerable; your heals smite.',
  'aspect.rain_storm.name': 'Storm of Light',
  'aspect.rain_storm.desc': 'Eighteen lighter arrows.',
  'aspect.rain_frost.name': 'Cold Light',
  'aspect.rain_frost.desc': 'Arrows chill.',
  'aspect.rain_return.name': 'Piercing Ring',
  'aspect.rain_return.desc': 'Arrows pierce twice and fly faster.',
  'aspect.mercy_ward.name': 'Warding Mercy',
  'aspect.mercy_ward.desc': 'Hits shield allies instead of healing.',
  'aspect.mercy_flock.name': 'Flock',
  'aspect.mercy_flock.desc': 'Seven arrows in a wide fan.',
  'aspect.mercy_zeal.name': 'Zeal',
  'aspect.mercy_zeal.desc': 'Healing +30%, crit +5%.',
  'aspect.plague_spread.name': 'Contagion',
  'aspect.plague_spread.desc': 'Wider; blight spreads on death.',
  'aspect.plague_rot.name': 'Rot',
  'aspect.plague_rot.desc': 'Also bleeds.',
  'aspect.plague_bloom.name': 'Plague Bloom',
  'aspect.plague_bloom.desc': 'The hex lingers and heals allies inside.',
  'aspect.gravity_well.name': 'Well',
  'aspect.gravity_well.desc': 'A wide, long pull.',
  'aspect.gravity_crush.name': 'Crush',
  'aspect.gravity_crush.desc': 'Double damage and a stun.',
  'aspect.gravity_echo.name': 'Echoing Hex',
  'aspect.gravity_echo.desc': 'Cast far more often.',
  'aspect.dread_silence.name': 'Silence',
  'aspect.dread_silence.desc': 'A full second of stun.',
  'aspect.dread_mark.name': 'Mark of Dread',
  'aspect.dread_mark.desc': 'Crit +10%; curses last longer.',
  'aspect.dread_wide.name': 'Spreading Dread',
  'aspect.dread_wide.desc': 'Much wider and lingering.',
  'aspect.iron_wall.name': 'Iron Wall',
  'aspect.iron_wall.desc': '+30 armour, +20% thorns.',
  'aspect.iron_mirror.name': 'Iron Mirror',
  'aspect.iron_mirror.desc': 'Thorns scale with armour.',
  'aspect.iron_pulse.name': 'Iron Pulse',
  'aspect.iron_pulse.desc': 'Taking hits shakes the ground around you.',
  'aspect.dread_chains.name': 'Chains',
  'aspect.dread_chains.desc': 'Enemies are chilled heavily.',
  'aspect.dread_terror.name': 'Terror',
  'aspect.dread_terror.desc': 'Enemies are briefly stunned.',
  'aspect.dread_feast.name': 'Feast',
  'aspect.dread_feast.desc': '+8% lifesteal.',
  'aspect.valor_charge.name': 'Valiant Charge',
  'aspect.valor_charge.desc': 'The oath opens with a lunge.',
  'aspect.valor_banner.name': 'Banner',
  'aspect.valor_banner.desc': 'Wider; aura radius +30%.',
  'aspect.valor_rally.name': 'Rally',
  'aspect.valor_rally.desc': 'The oath heals allies.',
  'aspect.swarm_plague.name': 'Plague Imps',
  'aspect.swarm_plague.desc': 'Imps spit blight.',
  'aspect.swarm_endless.name': 'Endless Swarm',
  'aspect.swarm_endless.desc': 'Seven imps, briefly.',
  'aspect.swarm_bond.name': 'Bound Swarm',
  'aspect.swarm_bond.desc': 'Summons +25%.',
  'aspect.fiend_tyrant.name': 'Tyrant',
  'aspect.fiend_tyrant.desc': 'A huge fiend that terrifies and taunts.',
  'aspect.fiend_bound.name': 'Bound Fiend',
  'aspect.fiend_bound.desc': 'Permanent. 90% of the damage you take falls on the fiend.',
  'aspect.fiend_twin.name': 'Twin Fiends',
  'aspect.fiend_twin.desc': 'Two fiends, shorter lived.',
  'aspect.wraith_chill.name': 'Frost Wraith',
  'aspect.wraith_chill.desc': 'Bolts chill.',
  'aspect.wraith_pair.name': 'Pair of Wraiths',
  'aspect.wraith_pair.desc': 'Two wraiths.',
  'aspect.wraith_lasting.name': 'Lingering Wraith',
  'aspect.wraith_lasting.desc': 'Stays 20 s.',
  'aspect.bear_mountain.name': 'Mountain',
  'aspect.bear_mountain.desc': '+20% health, +15 armour.',
  'aspect.bear_maul.name': 'Maul',
  'aspect.bear_maul.desc': 'Slashes may stun.',
  'aspect.bear_thick.name': 'Thick Hide',
  'aspect.bear_thick.desc': 'Longer regeneration and a shield.',
  'aspect.stalker_shadow.name': 'Shadow',
  'aspect.stalker_shadow.desc': 'A moment of invulnerability on the pounce.',
  'aspect.stalker_hunt.name': 'Hunt',
  'aspect.stalker_hunt.desc': 'Crit +12%, speed +8%.',
  'aspect.stalker_frenzy.name': 'Frenzy',
  'aspect.stalker_frenzy.desc': 'Cast much more often.',
  'aspect.lion_pride.name': 'Pride',
  'aspect.lion_pride.desc': 'Every form brings two lion cubs.',
  'aspect.lion_roar.name': 'Roar',
  'aspect.lion_roar.desc': 'Wider roar that also Weakens.',
  'aspect.lion_heart.name': 'Lionheart',
  'aspect.lion_heart.desc': 'Below 35% health, heal 30% (once per 20 s).',
  'aspect.fury_wave.name': 'Wave',
  'aspect.fury_wave.desc': 'Wider, stronger nova.',
  'aspect.fury_lingering.name': 'Lingering Fury',
  'aspect.fury_lingering.desc': 'The nova lingers for 3 s.',
  'aspect.fury_shock.name': 'Shockwave',
  'aspect.fury_shock.desc': 'The nova stuns.',
  'aspect.focus_pierce.name': 'Piercing Focus',
  'aspect.focus_pierce.desc': '+2 pierce.',
  'aspect.focus_crit.name': 'Deadly Focus',
  'aspect.focus_crit.desc': 'Crit +15%, crit damage +30%.',
  'aspect.focus_swift.name': 'Swift Focus',
  'aspect.focus_swift.desc': 'Attack speed +20%.',
  'aspect.twin_storm.name': 'Storm of Spirits',
  'aspect.twin_storm.desc': '+2 more projectiles, −15% damage.',
  'aspect.twin_split.name': 'Split',
  'aspect.twin_split.desc': 'Projectile speed +30%.',
  'aspect.twin_echo.name': 'Echo',
  'aspect.twin_echo.desc': 'Every switch bursts around you.',
  'aspect.twin_trio.name': 'Trio',
  'aspect.twin_trio.desc': 'Three turrets, briefly.',
  'aspect.twin_link.name': 'Linked',
  'aspect.twin_link.desc': 'Rapid-fire turrets.',
  'aspect.twin_armored.name': 'Armoured',
  'aspect.twin_armored.desc': 'Tough turrets.',
  'aspect.cannon_mortar.name': 'Mortar',
  'aspect.cannon_mortar.desc': 'Explosive fire shells.',
  'aspect.cannon_frost.name': 'Frost Cannon',
  'aspect.cannon_frost.desc': 'Shells chill heavily.',
  'aspect.cannon_siege.name': 'Siege',
  'aspect.cannon_siege.desc': 'Lasts 20 s.',
  'aspect.tesla_coil.name': 'Great Coil',
  'aspect.tesla_coil.desc': 'Wider arcs, faster.',
  'aspect.tesla_stun.name': 'Stun Coil',
  'aspect.tesla_stun.desc': 'Arcs stun.',
  'aspect.tesla_pair.name': 'Twin Coils',
  'aspect.tesla_pair.desc': 'Two coils.',
  'aspect.march_endless.name': 'Endless March',
  'aspect.march_endless.desc': 'Longer Inspiration and Haste.',
  'aspect.march_wide.name': 'Wide March',
  'aspect.march_wide.desc': 'Reaches far.',
  'aspect.march_swift.name': 'Quick March',
  'aspect.march_swift.desc': 'Cast much more often.',
  'aspect.hymn_mend.name': 'Mending Hymn',
  'aspect.hymn_mend.desc': 'Stronger heals.',
  'aspect.hymn_shield.name': 'Shielding Hymn',
  'aspect.hymn_shield.desc': 'Also shields allies.',
  'aspect.hymn_requiem.name': 'Requiem',
  'aspect.hymn_requiem.desc': 'Your kills heal allies.',
  'aspect.war_drums.name': 'War Drums',
  'aspect.war_drums.desc': 'Allies also gain Fortify.',
  'aspect.war_cry_bard.name': 'Battle Cry',
  'aspect.war_cry_bard.desc': 'Enemies nearby are Weakened.',
  'aspect.war_song.name': 'War Song',
  'aspect.war_song.desc': 'Durations +25%.',

  // ------------------------------------------------------------ blessings
  'blessing.bl_might.name': 'Might',
  'blessing.bl_might.desc': '+12% damage.',
  'blessing.bl_vigor.name': 'Vigour',
  'blessing.bl_vigor.desc': '+15% max health.',
  'blessing.bl_haste.name': 'Quick Hands',
  'blessing.bl_haste.desc': '+12% attack speed.',
  'blessing.bl_wind.name': 'Wind',
  'blessing.bl_wind.desc': '+10% speed, dash recharges 15% faster.',
  'blessing.bl_focus.name': 'Focus',
  'blessing.bl_focus.desc': '+6% crit, +15% crit damage.',
  'blessing.bl_stone.name': 'Stone Skin',
  'blessing.bl_stone.desc': '+12 armour.',
  'blessing.bl_flow.name': 'Flow',
  'blessing.bl_flow.desc': '−10% cooldowns.',
  'blessing.bl_reach.name': 'Reach',
  'blessing.bl_reach.desc': '+15% area and aura radius.',
  'blessing.bl_greed.name': 'Greed',
  'blessing.bl_greed.desc': '+2 luck, +40% pickup radius.',
  'blessing.bl_lore.name': 'Lore',
  'blessing.bl_lore.desc': '+20% experience.',
  'blessing.bl_ember.name': 'Ember',
  'blessing.bl_ember.desc': 'Hits may burn; status effects +15%.',
  'blessing.bl_rime.name': 'Rime',
  'blessing.bl_rime.desc': 'Hits may chill.',
  'blessing.bl_spark.name': 'Spark',
  'blessing.bl_spark.desc': 'Kills may release chain lightning.',
  'blessing.bl_rot.name': 'Rot',
  'blessing.bl_rot.desc': 'Hits may blight; blight spreads on death.',
  'blessing.bl_void.name': 'Void',
  'blessing.bl_void.desc': 'Kills may implode nearby enemies.',
  'blessing.bl_light.name': 'Light',
  'blessing.bl_light.desc': 'Healing +20%; kills may heal you.',
  'blessing.bl_thorns.name': 'Thorns',
  'blessing.bl_thorns.desc': '+30% thorns.',
  'blessing.bl_leech.name': 'Leech',
  'blessing.bl_leech.desc': '+6% lifesteal.',
  'blessing.bl_legion.name': 'Legion',
  'blessing.bl_legion.desc': '+1 summon, summons +20%.',
  'blessing.bl_volley.name': 'Volley',
  'blessing.bl_volley.desc': '+1 projectile, −8% damage.',
  'blessing.bl_second_wind.name': 'Second Wind',
  'blessing.bl_second_wind.desc': 'Below 30% health, heal 35% (once per 30 s).',
  'blessing.bl_dash_fire.name': 'Burning Step',
  'blessing.bl_dash_fire.desc': 'Dashing bursts fire around you.',
  'blessing.bl_reset.name': 'Momentum',
  'blessing.bl_reset.desc': 'Kills reset your dash.',
  'blessing.bl_boom.name': 'Boom',
  'blessing.bl_boom.desc': 'Everything you kill explodes in fire.',
  'blessing.bl_necro.name': 'Grave Call',
  'blessing.bl_necro.desc': 'Slain monsters may rise as your skeletons.',
  'blessing.bl_fortune.name': 'Fortune',
  'blessing.bl_fortune.desc': 'Double loot.',
  'blessing.bl_glass.name': 'Glass',
  'blessing.bl_glass.desc': '×1.5 damage, ×0.7 max health.',
  'blessing.bl_bulwark.name': 'Bulwark',
  'blessing.bl_bulwark.desc': '+25 armour; taking hits may grant Fortify.',
  'blessing.bl_tempo.name': 'Tempo',
  'blessing.bl_tempo.desc': 'Casting grants a moment of Haste and Might.',
  'blessing.bl_martyr.name': 'Martyr',
  'blessing.bl_martyr.desc': 'Taking hits may heal allies around you.',

  // ------------------------------------------------------------ legendaries
  'item.sunspear.name': 'Sunspear',
  'item.sunspear.desc': 'A bow of dawn: arrows pierce three foes, crits burst in holy light. +10% crit.',
  'item.grave_edge.name': 'Grave Edge',
  'item.grave_edge.desc': 'A void claymore. Slain monsters may rise as your skeletons; summons +30%.',
  'item.frostbrand.name': 'Frostbrand',
  'item.frostbrand.desc': 'Twin frost bolts. Every debuff you apply also chills; chill stacks shatter.',
  'item.stormheart.name': 'Stormheart',
  'item.stormheart.desc': 'Three lightning arrows; hits may release chain lightning.',
  'item.heart_of_oak.name': 'Heart of Oak',
  'item.heart_of_oak.desc': '+25% health, +3 regen. Below 30% health, heal 30%.',
  'item.mirror_carapace.name': 'Mirror Carapace',
  'item.mirror_carapace.desc': '+30 armour, +20% thorns, thorns scale with armour.',
  'item.shroud_of_night.name': 'Shroud of Night',
  'item.shroud_of_night.desc': '+1 dash, faster recharge, +8% speed. Kills reset your dash.',
  'item.crown_of_ash.name': 'Crown of Ash',
  'item.crown_of_ash.desc': 'Everything you kill explodes. Status effects +30%.',
  'item.idol_of_legion.name': 'Idol of the Legion',
  'item.idol_of_legion.desc': '+2 summons, summons +40%.',
  'item.gambler_coin.name': "Gambler's Coin",
  'item.gambler_coin.desc': '+6 luck, +10% XP, double loot.',
  'item.wailing_horn.name': 'Wailing Horn',
  'item.wailing_horn.desc': '−15% cooldowns. Casting weakens enemies around you.',

  // ------------------------------------------------------------ crowd effects
  'crowd.cr_pack.name': 'Ghoul Pack',
  'crowd.cr_pack.desc': 'Five ghouls bearing your name close in.',
  'crowd.cr_hounds.name': 'Hounds',
  'crowd.cr_hounds.desc': 'Four grave hounds hunt the hero.',
  'crowd.cr_elite.name': 'Elite Knight',
  'crowd.cr_elite.desc': 'An elite bone knight in your name.',
  'crowd.cr_slow.name': 'Frostbite',
  'crowd.cr_slow.desc': 'Heavy chill for 6 s.',
  'crowd.cr_weak.name': 'Weakness',
  'crowd.cr_weak.desc': 'Weak for 8 s.',
  'crowd.cr_fragile.name': 'Fragility',
  'crowd.cr_fragile.desc': 'Vulnerable for 8 s.',
  'crowd.cr_corruption.name': 'Corruption',
  'crowd.cr_corruption.desc': 'The boss comes sooner.',
  'crowd.cr_revenant.name': 'Revenant',
  'crowd.cr_revenant.desc': 'A fallen hero rises next to them.',
  'crowd.cr_boss.name': 'Summon the Boss',
  'crowd.cr_boss.desc': 'The realm boss arrives now. Once per realm.',
  'crowd.cr_heal.name': 'Mend',
  'crowd.cr_heal.desc': 'Heal 12%.',
  'crowd.cr_shield.name': 'Ward',
  'crowd.cr_shield.desc': 'A shield worth 25% health for 6 s.',
  'crowd.cr_haste.name': 'Haste',
  'crowd.cr_haste.desc': 'Haste for 5 s.',
  'crowd.cr_might.name': 'Might',
  'crowd.cr_might.desc': 'Might for 5 s.',
  'crowd.cr_potion.name': 'Potion',
  'crowd.cr_potion.desc': 'A potion of life for the hero.',
  'crowd.cr_loot.name': 'Gift',
  'crowd.cr_loot.desc': 'A rare item drops at their feet.',

  // ------------------------------------------------------------ druid and evolution summons
  'mob.shaggy_dragon.name': 'Shaggy Dragon',
  'mob.plague_dragon.name': 'Plague Dragon',
  'mob.chaos_serpent.name': 'Serpent of Chaos',
  'mob.bonded_dragon.name': 'Bonded Dragon',
  'mob.lesser_bear.name': 'Bear',
  'mob.guard_bear.name': 'Guardian Bear',
  'mob.pack_bear.name': 'Pack Bear',
  'mob.mother_bear.name': 'Mother Bear',
  'mob.bear_cub.name': 'Bear Cub',
  'mob.armored_bear.name': 'Armoured Bear',
  'mob.banner_bear.name': 'Banner Bear',
  'mob.crusher_bear.name': 'Crusher Bear',
  'mob.treant.name': 'Treant',
  'mob.ram_treant.name': 'Battering Treant',
  'mob.thorn_treant.name': 'Thorn Treant',
  'mob.quake_treant.name': 'Quake Treant',
  'mob.ram_treant_lesser.name': 'Young Treant',
  'mob.heal_treant.name': 'Healing Treant',
  'mob.sap_treant.name': 'Sap Treant',
  'mob.bark_treant.name': 'Bark Treant',
  'mob.elder_treant.name': 'Elder Treant',
  'mob.fortress_treant.name': 'Fortress Treant',
  'mob.hollow_treant.name': 'Hollow Treant',
  'mob.ember_treant.name': 'Ember Treant',
  'mob.wall_treant.name': 'Wall Treant',
  'mob.vine.name': 'Vine',
  'mob.snare_vine.name': 'Snaring Vine',
  'mob.thorn_net.name': 'Thorn Net',
  'mob.frost_net.name': 'Frost Net',
  'mob.grasping_net.name': 'Grasping Net',
  'mob.whip_vine.name': 'Whipping Vine',
  'mob.venom_whip.name': 'Venom Whip',
  'mob.long_whip.name': 'Long Whip',
  'mob.shield_vine.name': 'Sheltering Vine',
  'mob.barrier_vine.name': 'Barrier Vine',
  'mob.mending_vine.name': 'Mending Vine',
  'mob.wall_vine.name': 'Living Wall',
  'mob.flytrap.name': 'Flytrap',
  'mob.devourer_trap.name': 'Devourer',
  'mob.acid_trap.name': 'Acid Maw',
  'mob.giant_trap.name': 'Giant Maw',
  'mob.swift_trap.name': 'Swift Maw',
  'mob.venom_bush.name': 'Venom Bush',
  'mob.spore_bush.name': 'Spore Bush',
  'mob.numbing_bush.name': 'Numbing Bush',
  'mob.lure_trap.name': 'Lure',
  'mob.sticky_lure.name': 'Sticky Lure',
  'mob.bright_lure.name': 'Bright Lure',
  'mob.thorned_lure.name': 'Thorned Lure',
  'mob.strangler_root.name': 'Strangler Root',
  'mob.shade_wailer.name': 'Wailing Shade',
  'mob.shade_haunter.name': 'Haunter',
  'mob.shade_knight.name': 'Shade Knight',
  'mob.shade_reaper.name': 'Shade Reaper',
  'mob.shade_curser.name': 'Cursing Shade',
  'mob.imp_wraith.name': 'Wraith',
  'mob.imp_wraith_frost.name': 'Frost Wraith',
  'mob.imp_plague.name': 'Plague Imp',
  'mob.fiend_tyrant.name': 'Tyrant',
  'mob.lion_cub.name': 'Lion Cub',
  'mob.gob_tesla.name': 'Tesla Coil',
  'mob.gob_tesla_coil.name': 'Great Coil',
  'mob.gob_tesla_stun.name': 'Stun Coil',
  'mob.gob_turret_linked.name': 'Linked Turret',
  'mob.gob_turret_armored.name': 'Armoured Turret',
  'mob.gob_mortar.name': 'Goblin Mortar',
  'mob.gob_cannon_frost.name': 'Frost Cannon',
  // ------------------------------------------------------------ leaving, setup, gear classes, level gains
  'btn.exitRealm': 'Leave ({key})',
  'label.exitHint': 'Leave the realm: a one-second cast, broken by any hit. The hero is kept.',
  'label.exitCasting': 'Leaving the realm…',
  'toast.leaveHit': 'The way out closed: you were hit.',
  'btn.setup': 'Setup',
  'label.setupTitle': 'Hero setup',
  'label.setupHint': 'Rank points, aspects and gear. Everything here is kept between realms; levels and blessings belong to the realm.',
  'label.buildInRealmHint': 'You can spend points here too, but the menu has more room for the tree.',
  'label.vaultFromSetup': 'Items you do not need can be stashed or salvaged in the vault.',
  'btn.takeOff': 'Take off',
  'label.notForHero': 'not for this hero',
  'label.heroWeapons': 'Trained for: {list}',
  'label.wclass.heavy': 'heavy weapons',
  'label.wclass.light': 'light blades',
  'label.wclass.bow': 'bows and guns',
  'label.wclass.staff': 'staves and focuses',
  'build.wrongWeapon': 'This weapon is not for your hero',
  'build.bagFull': 'The backpack is full',
  'build.baseWeapon': 'This is the hero\'s own plain weapon',
  'label.levelGain': 'Rank {n} gives',
  'label.secShort': 's',
  'gain.damage': 'Damage',
  'gain.count': 'Count',
  'gain.radius': 'Radius',
  'gain.duration': 'Duration',
  // ------------------------------------------------------------ ui pass: shell, home, hints, objectives
  'nav.play': 'Play',
  'nav.heroes': 'Heroes',
  'nav.vault': 'Vault',
  'nav.pets': 'Companions',
  'nav.squad': 'Squad',
  'nav.guild': 'Guild',
  'nav.ranks': 'Rankings',
  'nav.profile': 'Profile',
  'nav.settings': 'Settings',
  'btn.toRealm': 'To the realm',
  'label.nextRealm': 'Next realm with',
  'label.noHeroYet': 'No hero in this slot yet',
  'label.heroesHintShort': 'Leave alive to keep the hero. Death frees the slot.',
  'label.watchTitle': 'Watch a friend',
  'label.howToPlay': 'How to play',
  'btn.showIntro': 'Show intro',
  'btn.later': 'Later',
  'intro.title': 'Before the first realm',
  'intro.sub': 'Four things worth knowing. Everything else the realm will teach.',
  'intro.go': 'Into the realm',
  'intro.move.title': 'Move and attack',
  'intro.move.text': 'WASD to move, hold the left mouse button to attack toward the cursor, Space to dash through danger.',
  'intro.skills.title': 'Skills and build',
  'intro.skills.text': 'Skills sit on {keys}. Level-ups offer cards: a rank of your own skill or a blessing. {build} opens your build, gear and stats.',
  'intro.goal.title': 'The goal of a realm',
  'intro.goal.text': 'Slaying monsters raises the corruption; when it fills, the boss comes. Slay it and the realm collapses into a new one. Rank grows from every realm and stays with the hero.',
  'intro.leave.title': 'Leaving and dying',
  'intro.leave.text': 'Press {key} to cast your way out: a one-second channel, broken by any hit. A hero who leaves alive keeps rank, kit and gear. A dead hero becomes a revenant and frees the slot.',
  'hint.draft': 'Level-up: pick a card with Z, X or C. Skill ranks add numbers, blessings add rules for this realm only.',
  'hint.bag': 'The item went to your backpack. Equip or take off gear in the build panel ({key}).',
  'hint.rank': 'A new rank point! Spend it here through Tab or later in the menu under Setup.',
  'feed.pickedItem': 'Picked up: {item}',
  'obj.open': 'Slay monsters: the corruption calls the boss.',
  'obj.boss': 'Slay the {boss}!',
  'obj.closing': 'The realm collapses in {s}s. A new one awaits.',
  'label.hints': 'Tips and intro',
  'btn.resetHints': 'Show again',
  'toast.hintsReset': 'Tips will show again.',
  // ------------------------------------------------------------ slots, touch controls
  'label.newHeroSlot': 'The new hero will take slot {n}.',
  'label.slotsAllTaken': 'Every slot holds a hero',
  'label.slotsAllTakenHint': 'Every slot holds a living hero. Continue one of them, or let one go on the Play screen.',
  'toast.heroResumed': 'This slot already holds a hero: continuing as {name}.',
  'btn.exit': 'Leave',
  'set.touch': 'Touch controls',
  'set.touchHint': 'Two thumb sticks and on-screen buttons instead of keyboard and mouse.',
  'set.touch.auto': 'Follow the device',
  'set.touch.on': 'Always on',
  'set.touch.off': 'Always off',
  'set.fullscreen': 'Fullscreen',
  'btn.fullscreenOn': 'Enter',
  'btn.fullscreenOff': 'Leave',
  'intro.touch.title': 'Thumbs on glass',
  'intro.touch.text': 'The left half of the screen walks, the right half aims and fires. Skills and potions sit under your right thumb; ≡ opens the menu.',
  'hint.draftTouch': 'Level-up: tap a card. Skill ranks add numbers, blessings add rules for this realm only.',
  'hint.bagTouch': 'The item went to your backpack. Equip or take off gear with the ▤ button.',
  'intro.skillsTouch': 'Skills and potions sit under your right thumb. Level-ups offer cards: a rank of your own skill or a blessing. ▤ opens your build, gear and stats.',
  'intro.leaveTouch': 'The ≡ menu leaves the realm: a one-second cast, broken by any hit. A hero who leaves alive keeps rank, kit and gear. A dead hero becomes a revenant and frees the slot.',
  'ctl.v.leftHalf': 'Left half of the screen',
  'ctl.v.rightHalf': 'Right half (auto without it)',
  'ctl.v.skillBtns': 'Buttons under the right thumb',
  'ctl.v.consRow': 'Row above the skills',
  'ctl.v.tapCard': 'Tap the card',
  'btn.send': 'Send',
  'label.chatPlaceholderTouch': 'Message…',
};
